import axios from 'axios';

export const fetchDropdowns = async (fields, setDropdownData) => {
  for (const field of fields) {
    if (field.api) {
      try {
        const response = await axios.get(field.api);
        setDropdownData(prev => ({
          ...prev,
          [field.fields]: response.data.map(item => ({
            id: item._id || item.id,
            label: item[field.apiField] || item.name,
          }))
        }));
      } catch (err) {
        console.error(`Dropdown fetch failed for ${field.fields}`, err);
      }
    }

    if (field.subfields) {
      for (const sub of field.subfields) {
        if (sub.api) {
          try {
            const response = await axios.get(sub.api);
            setDropdownData(prev => ({
              ...prev,
              [sub.fields]: response.data.map(item => ({
                id: item._id || item.id,
                label: item[sub.apiField] || item.name,
              }))
            }));
          } catch (err) {
            console.error(`Dropdown fetch failed for ${sub.fields}`, err);
          }
        }
      }
    }
  }
};

export const prefillArrayFields = (fields, formData, setFormData) => {
  const updated = { ...formData };
  fields.forEach((field) => {
    if (field.subfields) {
      const prefilled = field.subfields.find(sf => sf.Prefilled);
      if (prefilled?.Prefilled) {
        updated[field.fields] = prefilled.Prefilled.map((question, i) => ({
          ...formData[field.fields]?.[i],
          [prefilled.fields]: question
        }));
      }
    }
  });
  setFormData(updated);
};
